import React, { Component } from "react";
import Constants from "Helpers/Constants";
import axios from "axios";
import init from "Helpers/WindowToken";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { Navigate } from "react-router-dom";

import { Card, Grid, InputLabel, MenuItem, Select, TextField } from "@mui/material";

import MDBox from "components/MDBox";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDButton from "components/MDButton";

export default class AddAmenity extends Component {
  state = {
    title: "",
    text: "",
    icon: null, // file
    status: "active",
    is_delete: "no",

    loading: false,
    notification: false,
    message: "",
    notiColor: "success",
    redirect: false,
  };

  handleInput = (e) => {
    const { name, value, files } = e.target;
    if (name === "icon") {
      this.setState({ icon: files[0] || null });
    } else {
      this.setState({ [name]: value });
    }
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const { title, text, icon, status, is_delete } = this.state;

    // basic validation
    if (!title) {
      this.setState({ notification: true, notiColor: "warning", message: "Title is required!" });
      setTimeout(() => this.setState({ notification: false, message: "" }), 2000);
      return;
    }

    if (init() !== "success") {
      window.location.assign("/signin");
      return;
    }

    const fd = new FormData();
    fd.append("title", title);
    fd.append("text", text);
    fd.append("status", status);
    fd.append("is_delete", is_delete);
    if (icon) fd.append("client_image", icon); // backend expects client_image

    this.setState({ loading: true });

    axios
      .post(Constants.postUrls.createAmenity, fd)
      .then((resp) => {
        this.setState({
          notification: true,
          notiColor: "success",
          message: resp.data?.message || "Amenity created!",
          loading: false,
        });
        setTimeout(() => this.setState({ notification: false, message: "", redirect: true }), 1400);
      })
      .catch((err) => {
        this.setState({
          notification: true,
          notiColor: "warning",
          message: err?.response?.data?.message || "Create failed",
          loading: false,
        });
        setTimeout(() => this.setState({ notification: false, message: "" }), 3000);
      });
  };

  render() {
    if (this.state.redirect) return <Navigate to="/amenities" />;

    return (
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox pt={6} pb={3}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
            >
              <MDTypography variant="h6" color="white">
                Create Amenity
              </MDTypography>
            </MDBox>

            <MDBox py={3} px={2}>
              <form onSubmit={this.handleSubmit}>
                <Grid container spacing={2}>
                  <Grid item sm={6}>
                    <TextField
                      label="Title"
                      name="title"
                      value={this.state.title}
                      onChange={this.handleInput}
                      style={{ width: "100%" }}
                    />
                  </Grid>

                  <Grid item sm={6}>
                    <InputLabel>Status</InputLabel>
                    <Select
                      name="status"
                      value={this.state.status}
                      onChange={(e) => this.setState({ status: e.target.value })}
                      style={{ width: "100%", height: 45 }}
                    >
                      <MenuItem value="active">Active</MenuItem>
                      <MenuItem value="inactive">Inactive</MenuItem>
                    </Select>
                  </Grid>

                  <Grid item sm={12}>
                    <TextField
                      label="Small Text"
                      name="text"
                      value={this.state.text}
                      onChange={this.handleInput}
                      multiline
                      rows={3}
                      style={{ width: "100%" }}
                    />
                  </Grid>

                  <Grid item sm={12}>
                    <TextField
                      type="file"
                      label="Icon"
                      name="icon"
                      focused
                      onChange={this.handleInput}
                      style={{ width: "100%" }}
                    />
                  </Grid>

                  <Grid item sm={6}>
                    <InputLabel>Is Delete</InputLabel>
                    <Select
                      name="is_delete"
                      value={this.state.is_delete}
                      onChange={(e) => this.setState({ is_delete: e.target.value })}
                      style={{ width: "100%", height: 45 }}
                    >
                      <MenuItem value="no">No</MenuItem>
                      <MenuItem value="yes">Yes</MenuItem>
                    </Select>
                  </Grid>

                  <Grid item sm={12}>
                    <MDButton variant="contained" size="small" color="info" type="submit">
                      {this.state.loading ? "Creating..." : "Create"}
                    </MDButton>
                  </Grid>
                </Grid>
              </form>
            </MDBox>

            <MDSnackbar
              color={this.state.notiColor}
              icon="notifications"
              title="Amenities Admin"
              content={this.state.message}
              dateTime="Just now"
              open={this.state.notification}
            />
          </Card>
        </MDBox>
      </DashboardLayout>
    );
  }
}
